import { i18n } from '@/app/I18n';
export function reserveTicketsPayload(quantities, session, details = {}, data = {}) {
    const tickets = [];
    for (const [id, { quantity, price }] of Object.entries(quantities)) {
        for (let i = 0; i < quantity; i++) {
            tickets.push({
                ticket_type_id: id,
                face_value: price,
                // `undefined` not `null`, so that the property is completely omitted from the JSON payload.
                event_session_id: session ? session.id : undefined,
                admit_name: details[id] ? details[id][i].name : undefined,
                admit_email: details[id] ? details[id][i].email : undefined,
                handler_data: data[id] ? data[id][i] : undefined,
            });
        }
    }
    return tickets;
}
// TODO Consider support min and max values other than 1 e.g.
//   if (groups.length !== 1) return false
//   const g = groups[0]
//   return g.types.length === 1 && g.min_tickets_per_order === g.max_tickets_per_order
// Will also need to make changes where this is used to set quantity to 1.
export function exactlyOneTicket(groups) {
    return (groups.length === 1 &&
        groups[0].types.length === 1 &&
        groups[0].min_tickets_per_order === 1 &&
        groups[0].max_tickets_per_order === 1);
}
export function getButtonLabel(flexibleTickets, giftOfMembership, totalSelectedTickets) {
    if (flexibleTickets) {
        if (giftOfMembership) {
            return i18n.tc(`reserve.buttonLabel.member`);
        }
        else {
            return i18n.tc(`reserve.buttonLabel.passes`, totalSelectedTickets);
        }
    }
    else {
        return i18n.tc(`reserve.buttonLabel.tickets`, totalSelectedTickets);
    }
}
